import { Box, styled } from '@mui/material';

type Props = {
  entityId: {
    label: string;
    value: string;
  }[];
};

export const EntityValues = ({ entityId = [] }: Props) => {
  const labelsToShow = entityId.slice(0, 2).map((e) => e.label);
  const remainingCount = entityId.length - labelsToShow.length;

  return (
    <PillsWrapper>
      {labelsToShow.map((label, index) => (
        <Pill key={index}>{label}</Pill>
      ))}
      {remainingCount > 0 && <Pill>{` + ${remainingCount}`}</Pill>}
    </PillsWrapper>
  );
};

const PillsWrapper = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  justifyContent: 'center',
  verticalAlign: 'middle',
}));

const Pill = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: theme.spacing(2),
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  fontSize: 10,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
}));
